// extracted by mini-css-extract-plugin
module.exports = {"footer":"WelcomeGenaiFeedback_footer__2lPWe","footerTrigger":"WelcomeGenaiFeedback_footerTrigger__CpdJt"};